module.exports = __webpack_public_path__ + "static/video5-4fbbc8263ffe0aeb20a33a3b2f709d18.png";